export default {
  CREATE_TASK: () => `/task/createTask`,
  CREATE_CONTACT_TASK: () => `/taskContact`,
  // GET_TASK: (query) => `/task/getAllTask?${query}`,
  GET_TASK: (query) => {
    const params = new URLSearchParams(query).toString();
    return `/task/getAllTask?${params}`;
  },
  UPDATE_TASK: (id) => `/task/updateTask/${id}`,
  CREATE_TRIP: () => `/ka_trip`,
  UPDATE_TRIP_BY_ID: (id) => `/ka_trip/${id}`,
  DELETE_TRIP: (id) => `/ka_trip/${id}`,
  DELETE_TASK_TRIP: (id) => `/taskTrip/${id}`,
  UPDATE_CANCEL_BOOKING_BY_ID: (id, type) => `/cancelBooking/${type}/${id}`,
  TASK_BOOKING_VIA_TRIP: () => `/taskTrip`,
  GET_ALL_DELETED_TASK: () => `/getAllDeletedTask`,
  GET_TASK_BY_ID: (id) => `/task/getTaskBy/${id}`,
  CHECKLIST_REPLY: (id) => `/task/${id}/checklist/reply`,
  GET_TASK_ID: (id) => `/taskTrip/getByTaskId/${id}`,
  DELETE_TASK: (id) => `/task/deleteTask/${id}`,
  UPDATE_CHILD_TASK: (parentId) => `/task/updateParentTask/${parentId}`,
  GET_TRAVEL_BY_TASK: (id, query) => `/travellerDetails/getByTaskId/${id}?${query}`,
  GET_TASK_CONTACT_BY_ID: (id) => `/taskContact/getByTaskId/${id}`,
  UPDATE_TASK_GMAIL_WHATSAAP: (id) => `/task/updateTask/${id}`,
  GET_ALL_TASK: (id, startDate, endDate) =>
    `/task/getAllDateTask?boardId=${id}${startDate ? `&startDate=${startDate}` : ''}${endDate ? `&endDate=${endDate}` : ''}`,
  MOVE_TASK_DRAG_DROP: () => `/task/updateItemsDisplayOrder`,
  TASK_LINK_DATA: () => `/emailLink`,
  GET_TASK_LINK_DATA: (id) => `/emailLink/${id}`,
  DELETE_TASK_ATTACHEMENT: (id, attachId) => `/task/${id}/attachments/${attachId}`,
  GET_ALL_DEPENDENCIES: () => `/taskDependency`,
  GET_TASK_DEPENDENCIES: (taskId) => `/taskDependency/task/${taskId}`,
  CREATE_DEPENDENCY: () => `/taskDependency`,
  DELETE_DEPENDENCY: (id) => `/taskDependency/${id}`,
  GET_CHAT_DETAILS: (id, query) => `/task/getChatsDetails/${id}?${query}`,
  GET_TRIP_BY_TASKID: (id) => `/connectTripToTask/getbyTaskId/${id}`,
  GET_TRIP_BY_ID: (id, query) => `/ka_trip/${id}?${query ? query : ""}`
};
